import type { PumpStatus } from "@tandemdiabetes/sugarmate-api-react-client"
import { GlucoseMonitorIcon } from "@tandemdiabetes/sugarmate-react-components"
import classNames from "classnames"

import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"

import styles from "./PumpStatus.module.scss"

import { useIsPumpStatusSensorNearlyExpired } from "src/hooks"

export interface Props extends ComponentPropsWithoutRef<"svg"> {
  pumpStatus: PumpStatus;
  isSensorExpirationStale: boolean;
}

export const PumpSensorExpirationIcon = forwardRef<SVGElement, Props>(
  function PumpSensorExpirationIcon(props: Props, propRef: Ref<SVGElement>) {
    const {
      pumpStatus,
      isSensorExpirationStale,
      ...svgProps
    } = props

    const isSensorNearlyExpired = useIsPumpStatusSensorNearlyExpired(pumpStatus)

    return (
      <GlucoseMonitorIcon
        {...svgProps}
        className={classNames(
          svgProps.className,
          isSensorNearlyExpired && !isSensorExpirationStale && styles.expiringIcon,
        )}
        ref={propRef}
      />
    )
  },
)
